module.exports = __webpack_public_path__ + "static/media/DG8960-ben3.65caeee4.png";